import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { IServerErrorResponse } from '../../types';
import { BASE_URL } from '../../constants/endpoints';
import { trackMixPanel } from '../../services/mixpanel.service';

interface IProps {
  customerId: string,
  accountExternalId: string,
  queryKey?: string;
}

export interface IAchOutLimits {
  balance: number;
  dailyLimit: number;
  monthlyLimit: number;
  [key: string]: number;
}

export const useGetAchOutLimits = ({ customerId, accountExternalId, queryKey }: IProps, onSuccess: (data: IAchOutLimits) => void, onError: (errData: {errCode: number, errMsg: string}) => void) => useQuery(
  queryKey || 'ach-out-limits',
  async () => {
    const { data } = await httpService.get(`${BASE_URL}/api/v2/user/${customerId}/${accountExternalId}/ach/out/limits`);
    return data;
  },
  {
    enabled: false,
    retry: 1,
    onSuccess: (data: IAchOutLimits) => {
      onSuccess(data);
    },
    onError: (_e: IServerErrorResponse) => {
      const errData = _e?.response?.data?.errors?.[0];
      const errCode = errData?.code;
      const errMsg = errData?.localizedMessage;
      trackMixPanel('View ACH to 3rd Party - Error Occurred', {
        errorCode: errCode,
        errorMessage: errMsg,
      });
      onError({ errCode, errMsg });
    },
  },
);
